import React, { ReactNode } from "react";
import { Route } from "react-router-dom";

import { PublicConfigurationProvider } from "../configuration/public/PublicConfigurationProvider";

export interface PublicRouteProps {
    path: string;
    component: ReactNode;
}

export const PublicRoute: React.VFC<PublicRouteProps> = ({ path, component }: PublicRouteProps) => {
    return (
        <Route path={path} exact>
            <PublicConfigurationProvider>{component}</PublicConfigurationProvider>
        </Route>
    );
};
